var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.diffSign === 'N')?_c('span',[_vm._v("正常数据")]):_vm._e(),(_vm.row.diffSign === 'Y')?_c('span',{staticStyle:{"color":"#E64652"}},[_vm._v("差异数据")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }